import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { useProductContext } from '../../../../context/products';
import { Article, useArticlesGet } from '../../../../hooks/api/article';
import { formatDate } from '../../../../utils';
import { IconInfoTrac, IconInfoPublisher } from '../../../Common/Icon';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './index.module.scss';
import { useCategoryGet, useSubCategoryGet } from '../../../../hooks/api/category';
import CardSlider from './CardSlider';

interface CardSliderProps {
  data?: Article[];
  label?: string;
  icon?: React.ReactNode;
}

// function CardSlider({ data, icon, label }: CardSliderProps): React.ReactNode {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const isMediumSize = useMediaQuery({ query: '(max-width: 1680px)' });
//   const isLargeSize = useMediaQuery({ query: '(max-width: 2560px)' });
//   const isTablet = useMediaQuery({ query: '(max-width: 1240px)' });

//   // eslint-disable-next-line no-nested-ternary, unicorn/no-nested-ternary
//   const slidesToShow = isTablet ? 3 : isMediumSize ? 4 : isLargeSize ? 4 : 5;

//   const settings = {
//     arrows: false,
//     infinite: false,
//     speed: 700,
//     cssEase: 'ease-in-out',
//     slidesToShow,
//     // autoplay: true,
//     autoplaySpeed: 3000,
//     // pauseOnHover: true,
//     slidesToScroll: 1,
//     beforeChange: (_: number, next: number) => setCurrentSlide(next),
//   };

//   const totalSlides = data?.length || 1;
//   const visibleSlides = slidesToShow;
//   const maxSlideIndex = Math.max(totalSlides - visibleSlides, 1);

//   const progressPercent = Math.min((currentSlide / maxSlideIndex) * 100, 100);

//   return (
//     <div className={styles.sliderWrapper}>
//       <Slider {...settings}>
//         {data?.map((item) => (
//           <div key={item.id} className={styles.cardWrapper}>
//             <div className={styles.card}>
//               <div className={styles.info}>
//                 <div className={styles.label}>
//                   {icon}
//                   <span>{label}</span>
//                 </div>
//                 <span>{formatDate(item.createdAt)}</span>
//               </div>
//               <div className={styles.content}>
//                 <h4>{item.title}</h4>
//                 <span>Category / Subcategory</span>
//               </div>
//             </div>
//           </div>
//         ))}
//       </Slider>
//       <div className={styles.progressBarWrapper}>
//         <div className={styles.progressBarContent}>
//           <div className={styles.progressBar} style={{ width: `${progressPercent}%` }} />
//         </div>
//       </div>
//     </div>
//   );
// }

export default function RecentArticles(): React.ReactNode | null {
  const { data: products } = useProductContext();
  const articlesGet = useArticlesGet({ params: { pageSize: '100', status: 'published' } });
  const [activeTab, setActiveTab] = useState<string>('');

  useEffect(() => {
    if (products?.length && !activeTab) {
      setActiveTab(products[0].id);
    }
  }, [products, activeTab]);

  const onChange = (key: string) => setActiveTab(key);

  const items: TabsProps['items'] = products?.map((product) => {
    const articles = articlesGet.data?.data
      .filter((a: Article) => a.product.id === product.id && a.status === 'published')
      .slice(0, 8) || [];

    return {
      key: product.id,
      label: product.name,
      children: (
        <CardSlider
          data={articles}
          label={product.name}
          icon={product.logo}
        />
      ),
    };
  }) || [];

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <h2>Recent articles</h2>
      </div>
      <Tabs
        size="large"
        style={{ fontSize: 16, color: '#284F66' }}
        activeKey={activeTab}
        items={items}
        onChange={onChange}
        destroyInactiveTabPane={false}
      />
    </div>
  );
}
